import Login from '../Login'
import PasswordLost from '../PasswordLost'
import PasswordReset from '../PasswordReset'

export const routes = [
  {path: '/admin/auth', component: Login, exact: true, public: true, noContainer: true},
  {path: '/admin/auth/password/lost', component: PasswordLost, exact: true, public: true, noContainer: true},
  {path: '/admin/auth/password/reset/:token', component: PasswordReset, exact: true, public: true, noContainer: true},
  {path: '/admin/auth/password/create/:token', component: PasswordReset, exact: true, public: true, noContainer: true},
];
